const STORAGE_LOG_PREFIX = "[WD storage]";

const getStorage = (storageName = "localStorage") => {
  if (typeof window === "undefined") return null;
  try {
    return window[storageName] || null;
  } catch (error) {
    console.warn(`${STORAGE_LOG_PREFIX} ${storageName} není dostupný`, error);
    return null;
  }
};

export const safeGetStorageItem = (key, { storageName = "localStorage", log = false } = {}) => {
  const storage = getStorage(storageName);
  if (!storage) return null;

  try {
    const value = storage.getItem(key);
    if (log && value !== null) console.log(`${STORAGE_LOG_PREFIX} loaded ${storageName}.${key}`);
    return value;
  } catch (error) {
    console.warn(`${STORAGE_LOG_PREFIX} nelze načíst ${storageName}.${key}`, error);
    return null;
  }
};

export const safeSetStorageItem = (key, value, { storageName = "localStorage" } = {}) => {
  const storage = getStorage(storageName);
  if (!storage) return false;

  try {
    storage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn(`${STORAGE_LOG_PREFIX} nelze uložit ${storageName}.${key}`, error);
    return false;
  }
};

export const safeRemoveStorageItem = (key, { storageName = "localStorage", reason = "" } = {}) => {
  const storage = getStorage(storageName);
  if (!storage) return false;

  try {
    storage.removeItem(key);
    console.warn(
      `${STORAGE_LOG_PREFIX} removed ${storageName}.${key}${reason ? ` (${reason})` : ""}`,
    );
    return true;
  } catch (error) {
    console.warn(`${STORAGE_LOG_PREFIX} nelze smazat ${storageName}.${key}`, error);
    return false;
  }
};

export const safeGetJSON = (
  key,
  fallbackValue = null,
  { storageName = "localStorage", removeInvalid = true } = {},
) => {
  const raw = safeGetStorageItem(key, { storageName });
  if (raw === null || raw === undefined || raw === "") return fallbackValue;

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn(`${STORAGE_LOG_PREFIX} invalid JSON v ${storageName}.${key}`, error);
    if (removeInvalid) {
      safeRemoveStorageItem(key, {
        storageName,
        reason: "invalid JSON",
      });
    }
    return fallbackValue;
  }
};

export const safeSetJSON = (key, value, { storageName = "localStorage" } = {}) =>
  safeSetStorageItem(key, JSON.stringify(value), { storageName });

export const safeGetBoolean = (
  key,
  fallbackValue = false,
  { storageName = "localStorage" } = {},
) => {
  const raw = safeGetStorageItem(key, { storageName });
  if (raw === null || raw === undefined || raw === "") return fallbackValue;
  if (raw === "true") return true;
  if (raw === "false") return false;

  const parsed = safeGetJSON(key, fallbackValue, { storageName, removeInvalid: true });
  return typeof parsed === "boolean" ? parsed : fallbackValue;
};

export const safeGetNumber = (
  key,
  fallbackValue = null,
  { storageName = "localStorage" } = {},
) => {
  const raw = safeGetStorageItem(key, { storageName });
  if (raw === null || raw === undefined || raw === "") return fallbackValue;
  const value = Number(raw);
  if (Number.isFinite(value)) return value;
  safeRemoveStorageItem(key, { storageName, reason: "invalid number" });
  return fallbackValue;
};
